<template>
  <div class="dd-business">
    <Header/>
    <Banner :image="bannerImage" title="商务合作" description="让我们一起创造更多可能"/>
    <Section title="联系我们">
      <div class="dd-business__table">
        <div class="dd-business__row">
          <div class="dd-business__left">
            <h4>广州数鸽科技有限公司</h4>
            <p>地址：广州市海珠区赤岗西路288号杨协成创意园D101-103</p>
            <p>电话：020-89448259</p>
          </div>
          <div class="dd-business__right">
            <h4>品牌合作</h4>
            <p>819841106@qq.com</p>
          </div>
        </div>
      </div>
    </Section>
    <Footer/>
  </div>
</template>

<script>
export default {
  data () {
    return {
      bannerImage: require('../assets/business.jpg')
    }
  }
}
</script>

<style lang="scss">
.dd-business {
  &__table {
    width: 100%;
    display: table;
  }
  &__row {
    display: table-row;
  }
  &__left,
  &__right {
    position: relative;
    display: table-cell;
    width: 50%;
    padding-bottom: 36px;

    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 70%;
      height:1px;
      background:rgba(153,153,153,1);
    }
  }
  h4 {
    font-size: 21px;
    font-weight: bold;
    margin-bottom: 27px;
  }
  p {
    margin: 12px 0;
  }
  @include media-tablet {
    &__left,
    &__right {
      display: block;
      width: 100%;

      &:after {
        width: 100%;
      }
    }
    &__right {
      margin-top: 30px;
    }
  }
}
</style>
